import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
});

class DisabledPage extends React.Component {
  render() {
    const {
      t,
    } = this.props;

    return (
      <div className="disabled-page">
        {appType === 'student' && t('Your account is either disabled or your school has no active modules.')}
        {appType === 'parent' && t('Parent accounts are disabled for this pupil.')}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(DisabledPage));
